const actions = {
  GET_SIMPL_DATA: 'GET_SIMPL_DATA',
  GET_SIMPL_DATA_SUCCESS: 'GET_SIMPL_DATA_SUCCESS',
  GET_SIMPL_DATA_FAILED: 'GET_SIMPL_DATA_FAILED',


  getSimplData: (offset, limit, search) => ({
    type: actions.GET_SIMPL_DATA,
    payload: { offset, limit, search },
  }),
  getSimplDataSuccess: (data, totalData) => ({
    type: actions.GET_SIMPL_DATA_SUCCESS,
    payload: { data, totalData },
  }),
  getSimplDataFailed: (error) => ({
    type: actions.GET_SIMPL_DATA_FAILED,
    payload: { error },
  }),

};

export default actions;
